import GasRCChart from "./GasRCChart";

const ChartsSection = () => {
	return (<GasRCChart />);
}

export default ChartsSection;